import { disallowedIsOneOfValueFields } from '../comparator/constants';
import { useConditionStateContext } from '../../../contexts';

/** checks for both isOneOf and isNotOneOf */
export const useIsOneOfCondition = (additionalCondition = true) => {
  const { field } = useConditionStateContext();
  const hasAllowedIsOneOfField = !disallowedIsOneOfValueFields.includes(field ?? '');

  return additionalCondition && hasAllowedIsOneOfField;
};
